angular.module('app.controllers').controller('ExhibitorsEditCtrl', ['$scope', '$location', 'UI', 'APIExhibitors', '$rootScope', 'APIRead2'].append(function(self, $location, UI, APIExhibitors, root, APIRead2) {
  var ref, ref1, ref2;
  self.id = parseInt(self.get('id')) || null;
  self.action = self.get('action') || null;
  if (((ref = root.user) != null ? ref.role : void 0) === 'exhibitor') {
    if (self.id !== ((ref1 = root.session) != null ? (ref2 = ref1.user) != null ? ref2.id : void 0 : void 0)) {
      return root.logout();
    }
  }
  APIRead2.get({
    id: self.id,
    entry_type: 'exhibitors'
  }, function(data) {
    var contact, i, j, len, ref3;
    self.data = data;
    if (self.action === 'add') {
      if (!self.isFavs('ex', self.data.exhibitor_id, -1)) {
        self.toggleFavs('ex', self.data);
      }
      self.toggleFavs('sc', self.data);
    }
    //$location.path("/aussteller/#{self.data.exhibitor_id}")
    self.customStat(self.id, 'page_view', self.data.exhibitor_name);
    contact = [];
    ref3 = ['exhibitor_name', 'street', 'zip_code', 'city', 'country'];
    for (j = 0, len = ref3.length; j < len; j++) {
      i = ref3[j];
      if (self.data[i] != null) {
        contact.push(self.data[i]);
      }
    }
    self.contact = contact.join("\n");
    return APIExhibitors.get({
      id: self.id,
      _entry: 'exhibitor'
    }, function(data) {
      angular.extend(self.data, data);
      if (self.data.mainvideo.is_yuotube) {
        return self.onYouTubeIframeAPIReady(self.data.mainvideo.id, self.id, self.data.video_title || self.data.exhibitor_name);
      } else if (self.data.mainvideo.is_vimeo) {
        return self.onVimeoIframeAPIReady(self.data.mainvideo.id, self.id, self.data.video_title || self.data.exhibitor_name);
      }
    }, function(response) {
      return UI.notify(false, response.error.data);
    });
  }, function(response) {
    return UI.notify(false, response.error.data);
  });
  self.openAcc = null;
  self.toggleAcc = function(ind, title = '') {
    return;
    if (self.openAcc !== ind) {
      self.customStat(self.id, 'job_seen', title);
      return self.openAcc = ind;
    } else {
      return self.openAcc = null;
    }
  };
  self.slick = {
    infinite: true,
    dots: true,
    arrows: true,
    dotsClass: 'slider-dots',
    customPaging: function(slider, i) {
      if (slider.slideCount === 1 || slider.slideCount === slider.options.slidesToShow) {
        return false;
      }
      return "<a class='slider-dots-item'></a>";
    },
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="slider-control slider-control-prev"></div>',
    nextArrow: '<div class="slider-control slider-control-next"></div>',
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    useCSS: false,
    cssEase: 'linear'
  };
  self.jobsLimit = 3;
  return self.setLimit = function() {
    return self.jobsLimit = 100;
  };
}));
